<template>
  <div style="background: #FBFCFB">
    <Header />
    <div class="banner">会员中心 优质服务</div>
    <el-container>
      <!-- 移除左侧菜单栏 -->
      <el-main style="min-height: 800px; padding: 0 78px;">
        <router-view />
      </el-main>
    </el-container>
    <Footer />
  </div>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";

export default {
  name: "LayoutUser",
  components: {
    Header,
    Footer,
  },
};
</script>

<style scoped lang="scss">
body {
  padding: 0;
  margin: 0;
}

.banner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 215px;
  border: 1px solid;
  position: relative;
  margin-bottom: 30px;
  box-sizing: border-box;
  background-image: url(~@/assets/user/user-banner.jpg);
  background-repeat: no-repeat;
  background-position: center center;
  -webkit-background-size: 100%;
  background-size: 100%;
  text-align: center;
  font-weight: 500;
  font-size: 42px;
  color: #ffffff;
  letter-spacing: 10px;
}

/* 调整容器样式 */
.el-container {
  margin-bottom: 50px;
  padding: 0 130px;
  box-sizing: border-box;
}

.el-main {
  padding: 0;
}
</style>
